export const CHILDREN_TYPES_IDS = {
  PETTY_CASH: '10',
  BANK: '11'
}